// extracted by mini-css-extract-plugin
export default {"update_details":"ActionButton_update_details__oOhiL"};